import { render, staticRenderFns } from "./UserFans.vue?vue&type=template&id=79a68b10&scoped=true&"
import script from "./UserFans.vue?vue&type=script&lang=js&"
export * from "./UserFans.vue?vue&type=script&lang=js&"
import style0 from "./UserFans.vue?vue&type=style&index=0&id=79a68b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a68b10",
  null
  
)

export default component.exports